'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _awsSdk = require('aws-sdk');

var _awsSdk2 = _interopRequireDefault(_awsSdk);

require('./checkout.css');

var _FishermanLogoNoText = require('./data/Fisherman-Logo-NoText.png');

var _FishermanLogoNoText2 = _interopRequireDefault(_FishermanLogoNoText);

var _aws = require('./utils/aws');

var _EmailForm = require('./forms/EmailForm');

var _EmailForm2 = _interopRequireDefault(_EmailForm);

var _ExistingDomainForm = require('./forms/ExistingDomainForm');

var _ExistingDomainForm2 = _interopRequireDefault(_ExistingDomainForm);

var _ExitConfirmation = require('./forms/ExitConfirmation');

var _ExitConfirmation2 = _interopRequireDefault(_ExitConfirmation);

var _Completion = require('./forms/Completion');

var _Completion2 = _interopRequireDefault(_Completion);

var _DomainChoicesForm = require('./forms/DomainChoicesForm');

var _DomainChoicesForm2 = _interopRequireDefault(_DomainChoicesForm);

var _DomainForm = require('./forms/DomainForm');

var _DomainForm2 = _interopRequireDefault(_DomainForm);

var _PaymentForm = require('./forms/PaymentForm');

var _PaymentForm2 = _interopRequireDefault(_PaymentForm);

var _SearchDomainsForm = require('./forms/SearchDomainsForm');

var _SearchDomainsForm2 = _interopRequireDefault(_SearchDomainsForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var formsConfig = {
  emailForm: {
    component: _EmailForm2.default,
    nextForm: null,
    previousForm: null,
    primaryStepCopy: 'Enter your email address',
    secondaryStepCopy: 'We\'ll send confirmation details.',
    primaryNavButtonCopy: 'Claim',
    secondaryNavButtonCopy: '',
    validate: function validate(_ref) {
      var email = _ref.email;
      return (/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(email)
      );
    },
    errorMessage: 'Enter a valid email',
    afterFormAction: function afterFormAction(_ref2) {
      var suggestedDomain = _ref2.suggestedDomain;
      return (0, _aws.getDomainSuggestions)(suggestedDomain + '.com');
    },
    afterFormStoreFieldName: 'domainChoices',
    asyncPayloadField: 'SuggestionsList'
  },
  domainOptionsForm: {
    component: _DomainForm2.default,
    nextForm: function nextForm(_ref3) {
      var domainConfigurationChoice = _ref3.domainConfigurationChoice;
      return domainConfigurationChoice === 'newDomain' ? 'domainChoicesForm' : 'completion';
    },
    previousForm: null,
    primaryStepCopy: 'Select an option',
    secondaryStepCopy: '',
    primaryNavButtonCopy: 'Select',
    secondaryNavButtonCopy: '',
    validate: function validate(_ref4) {
      var domainConfigurationChoice = _ref4.domainConfigurationChoice;
      return domainConfigurationChoice.length > 0;
    },
    errorMessage: 'Please choose an option.',
    afterFormAction: function afterFormAction(_ref5) {
      var domainConfigurationChoice = _ref5.domainConfigurationChoice,
          suggestedDomain = _ref5.suggestedDomain;

      if (domainConfigurationChoice === 'newDomain') {
        return (0, _aws.getDomainSuggestions)(suggestedDomain + '.com');
      }
      return null;
    },
    afterFormStoreFieldName: 'domainChoices',
    asyncPayloadField: 'SuggestionsList'
  },
  existingDomainForm: {
    component: _ExistingDomainForm2.default,
    nextForm: 'completion',
    previousForm: 'domainChoicesForm',
    primaryStepCopy: 'Enter your domain below.',
    secondaryStepCopy: 'It\'s free to connect a domain you already own.',
    primaryNavButtonCopy: 'Enter',
    secondaryNavButtonCopy: 'Back',
    validate: function validate(_ref6) {
      var existingDomain = _ref6.existingDomain;
      return existingDomain.length > 0;
    },
    errorMessage: 'Please enter your domain.',
    afterFormAction: null,
    afterFormStoreFieldName: null,
    asyncPayloadField: null
  },
  exitConfirmation: {
    component: _ExitConfirmation2.default,
    nextForm: null,
    previousForm: null,
    primaryStepCopy: 'Are you sure? You\'re almost done!',
    secondaryStepCopy: 'Your custom website is waiting for you',
    primaryNavButtonCopy: 'Exit',
    secondaryNavButtonCopy: 'Resume',
    validate: function validate() {
      return true;
    },
    errorMessage: '',
    afterFormAction: null,
    afterFormStoreFieldName: null,
    asyncPayloadField: null
  },
  completion: {
    component: _Completion2.default,
    nextForm: null,
    previousForm: 'paymentForm',
    primaryStepCopy: 'We\'ll get to work publishing your website',
    secondaryStepCopy: 'Keep an eye out for a confirmation email from Fisherman.',
    primaryNavButtonCopy: 'Done',
    secondaryNavButtonCopy: '',
    validate: function validate() {
      return true;
    },
    errorMessage: '',
    afterFormAction: null,
    afterFormStoreFieldName: null,
    asyncPayloadField: null
  },
  domainChoicesForm: {
    component: _DomainChoicesForm2.default,
    nextForm: 'completion',
    previousForm: 'domainChoicesForm',
    primaryStepCopy: 'Select a custom website URL',
    secondaryStepCopy: 'It\'s only $10/month.',
    primaryNavButtonCopy: 'Select',
    secondaryNavButtonCopy: 'Back',
    validate: function validate(_ref7) {
      var chosenDomain = _ref7.chosenDomain;
      return chosenDomain.length > 0;
    },
    errorMessage: 'Please choose a domain.',
    afterFormAction: null,
    afterFormStoreFieldName: null,
    asyncPayloadField: null
  },
  paymentForm: {
    component: _PaymentForm2.default,
    nextForm: 'completion',
    previousForm: null,
    primaryStepCopy: 'Purchase your website.',
    secondaryStepCopy: '',
    primaryNavButtonCopy: 'Purchase',
    secondaryNavButtonCopy: 'Back',
    validate: function validate() {
      return true;
    },
    errorMessage: '',
    afterFormAction: null,
    afterFormStoreFieldName: null,
    asyncPayloadField: null
  },
  searchDomainsForm: {
    component: _SearchDomainsForm2.default,
    nextForm: 'paymentForm',
    previousForm: 'domainChoicesForm',
    primaryStepCopy: 'Search for a domain',
    secondaryStepCopy: '',
    primaryNavButtonCopy: 'Select',
    secondaryNavButtonCopy: 'Back',
    validate: function validate(_ref8) {
      var chosenDomain = _ref8.chosenDomain;
      return chosenDomain.length > 0;
    },
    errorMessage: 'Please choose a domain.',
    afterFormAction: null,
    afterFormStoreFieldName: null,
    asyncPayloadField: null
  }
};

var Checkout = function (_React$Component) {
  _inherits(Checkout, _React$Component);

  function Checkout(props) {
    _classCallCheck(this, Checkout);

    var _this = _possibleConstructorReturn(this, (Checkout.__proto__ || Object.getPrototypeOf(Checkout)).call(this, props));

    _this.state = {
      isOpen: true,
      previousStep: null,
      currentStep: 'domainOptionsForm',
      primaryStepCopy: 'Select an option',
      secondaryStepCopy: '',
      primaryNavButtonCopy: 'Select',
      secondaryNavButtonCopy: '',
      errorMessage: '',
      email: '',
      domainConfigurationChoice: '',
      suggestedDomain: props.businessDomain,
      chosenDomain: '',
      existingDomain: '',
      searchDomainTerm: '',
      domainChoices: []
    };

    _this.onClose = _this.onClose.bind(_this);
    _this.onExit = _this.onExit.bind(_this);
    _this.onNewStep = _this.onNewStep.bind(_this);
    _this.onEmailChange = _this.onEmailChange.bind(_this);
    _this.goToStep = _this.goToStep.bind(_this);
    _this.setErrorMessage = _this.setErrorMessage.bind(_this);
    _this.resetErrorMessage = _this.resetErrorMessage.bind(_this);
    _this.onPostFormAction = _this.onPostFormAction.bind(_this);
    _this.onChooseDomain = _this.onChooseDomain.bind(_this);
    _this.onChooseDomainOption = _this.onChooseDomainOption.bind(_this);
    _this.onEnterExistingDomain = _this.onEnterExistingDomain.bind(_this);
    return _this;
  }

  _createClass(Checkout, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      _awsSdk2.default.config.update({
        region: 'us-east-1',
        credentials: new _awsSdk2.default.Credentials(process.env.AWS_ACCESS_KEY_ID, process.env.AWS_SECRET_ACCESS_KEY)
      });

      this.props.toLog && (0, _aws.sendNotificationEmail)('claimStarted', this.state.suggestedDomain);
    }
  }, {
    key: 'getCurrentForm',
    value: function getCurrentForm() {
      var _state = this.state,
          currentStep = _state.currentStep,
          email = _state.email,
          domainChoices = _state.domainChoices,
          chosenDomain = _state.chosenDomain,
          existingDomain = _state.existingDomain,
          domainConfigurationChoice = _state.domainConfigurationChoice,
          suggestedDomain = _state.suggestedDomain;


      var props = void 0;
      if (currentStep === 'emailForm') {
        props = {
          onChange: this.onEmailChange,
          email: email
        };
      } else if (currentStep === 'domainOptionsForm') {
        props = {
          domainConfigurationChoice: domainConfigurationChoice,
          onChange: this.onChooseDomainOption,
          suggestedDomain: suggestedDomain
        };
      } else if (currentStep === 'domainChoicesForm') {
        props = {
          domainChoices: domainChoices,
          chosenDomain: chosenDomain,
          onChooseDomain: this.onChooseDomain,
          onChangeForm: this.goToStep,
          formsConfig: formsConfig
        };
      } else if (currentStep === 'existingDomainForm') {
        props = {
          existingDomain: existingDomain,
          onChange: this.onEnterExistingDomain
        };
      }
      return formsConfig[this.state.currentStep].component(props);
    }
  }, {
    key: 'onEmailChange',
    value: function onEmailChange(e) {
      var value = e.target.value;

      this.setState({ email: value });
    }
  }, {
    key: 'goToStep',
    value: function goToStep(previousStep, currentStep, stepConfig) {
      var primaryStepCopy = stepConfig.primaryStepCopy,
          secondaryStepCopy = stepConfig.secondaryStepCopy,
          primaryNavButtonCopy = stepConfig.primaryNavButtonCopy,
          secondaryNavButtonCopy = stepConfig.secondaryNavButtonCopy;


      this.setState({
        currentStep: currentStep,
        previousStep: previousStep,
        primaryStepCopy: primaryStepCopy,
        secondaryStepCopy: secondaryStepCopy,
        primaryNavButtonCopy: primaryNavButtonCopy,
        secondaryNavButtonCopy: secondaryNavButtonCopy
      });
    }
  }, {
    key: 'onNewStep',
    value: function onNewStep(direction) {
      var _this2 = this;

      var stepOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      // direction: [next, back, prev]
      var _state2 = this.state,
          currentStep = _state2.currentStep,
          previousStep = _state2.previousStep;
      var _formsConfig$currentS = formsConfig[currentStep],
          nextForm = _formsConfig$currentS.nextForm,
          previousForm = _formsConfig$currentS.previousForm,
          validate = _formsConfig$currentS.validate,
          errorMessage = _formsConfig$currentS.errorMessage;


      var nextFormParsed = typeof nextForm === 'string' || !nextForm ? nextForm : nextForm(this.state);

      if (currentStep === 'exitConfirmation') {
        if (direction === 'next') {
          this.props.toLog && (0, _aws.sendNotificationEmail)('claimExited', this.state);
          this.onClose();
          this.props.onCompletion(false);
        } else {
          this.goToStep(formsConfig[previousStep].previousForm, previousStep, formsConfig[previousStep]);
        }
      } else if (currentStep === 'completion') {
        this.onCheckoutComplete(this.props.onCompletion);
        this.props.toLog && (0, _aws.sendNotificationEmail)('claimCompleted', this.state);
        this.onClose();
      } else if (direction === 'next') {
        if (validate(this.state)) {
          this.onPostFormAction(formsConfig[currentStep], function () {
            return _this2.goToStep(currentStep, nextFormParsed, formsConfig[nextFormParsed]);
          });
        } else {
          this.setErrorMessage(errorMessage);
        }
      } else if (direction === 'back') {
        this.goToStep(currentStep, previousForm, formsConfig[previousForm]);
      } else {
        this.goToStep(currentStep, stepOverride, formsConfig[stepOverride]);
      }
    }
  }, {
    key: 'onPostFormAction',
    value: function onPostFormAction(formConfig, cb) {
      var _this3 = this;

      var afterFormAction = formConfig.afterFormAction,
          afterFormStoreFieldName = formConfig.afterFormStoreFieldName,
          asyncPayloadField = formConfig.asyncPayloadField;


      if (afterFormAction !== null) {
        var afterFormActionFunc = afterFormAction(this.state);

        if (afterFormActionFunc) {
          afterFormActionFunc.then(function (data) {
            _this3.setState(_defineProperty({}, afterFormStoreFieldName, data[asyncPayloadField]), cb());
          });
        } else {
          cb();
        }
      } else {
        cb();
      }
    }
  }, {
    key: 'onChooseDomain',
    value: function onChooseDomain(chosenDomain) {
      this.setState({ chosenDomain: chosenDomain });
    }
  }, {
    key: 'onChooseDomainOption',
    value: function onChooseDomainOption(domainConfigurationChoice) {
      this.setState({ domainConfigurationChoice: domainConfigurationChoice });
    }
  }, {
    key: 'onEnterExistingDomain',
    value: function onEnterExistingDomain(e) {
      var value = e.target.value;

      this.setState({ existingDomain: value });
    }
  }, {
    key: 'onSearchDomain',
    value: function onSearchDomain() {
      // search for suggested domains using aws.js sdk
      // set value of domain choices to results
      // bound method
    }
  }, {
    key: 'onCheckoutComplete',
    value: function onCheckoutComplete() {
      var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.setState({ hasFinished: false }, cb(true));
    }
  }, {
    key: 'onPaidComplete',
    value: function onPaidComplete() {
      var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.setState({ hasPaid: false }, cb());
    }
  }, {
    key: 'onDomainComplete',
    value: function onDomainComplete() {
      var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.setState({ hasChosenDomain: false }, cb());
    }
  }, {
    key: 'onEmailComplete',
    value: function onEmailComplete() {
      var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.setState({ hasEnteredEmail: true }, cb());
    }
  }, {
    key: 'onExit',
    value: function onExit() {
      this.goToStep(this.state.currentStep, 'exitConfirmation', formsConfig.exitConfirmation);
    }
  }, {
    key: 'onClose',
    value: function onClose() {
      this.setState({ isOpen: false });
    }
  }, {
    key: 'setErrorMessage',
    value: function setErrorMessage(errorMessage) {
      var _this4 = this;

      this.setState({ errorMessage: errorMessage }, function () {
        return setTimeout(_this4.resetErrorMessage, 3000);
      });
    }
  }, {
    key: 'resetErrorMessage',
    value: function resetErrorMessage() {
      this.setState({ errorMessage: '' });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _state3 = this.state,
          isOpen = _state3.isOpen,
          currentStep = _state3.currentStep,
          suggestedDomain = _state3.suggestedDomain,
          primaryStepCopy = _state3.primaryStepCopy,
          secondaryStepCopy = _state3.secondaryStepCopy,
          primaryNavButtonCopy = _state3.primaryNavButtonCopy,
          secondaryNavButtonCopy = _state3.secondaryNavButtonCopy,
          errorMessage = _state3.errorMessage;

      return _react2.default.createElement(
        'div',
        { id: 'fc-checkout-background', style: { display: isOpen ? 'block' : 'none' } },
        _react2.default.createElement(
          'div',
          { id: 'fc-checkout-container' },
          _react2.default.createElement(
            'div',
            { id: 'fc-checkout-header' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement('img', { src: _FishermanLogoNoText2.default, alt: 'Fisherman Logo' })
            ),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'button',
              { id: 'fc-checkout-exit', onClick: this.onExit },
              '\xD7'
            )
          ),
          _react2.default.createElement(
            'div',
            { id: 'fc-checkout-content' },
            _react2.default.createElement(
              'div',
              { id: 'fc-checkout-form-copy-container' },
              _react2.default.createElement(
                'div',
                null,
                primaryStepCopy
              ),
              secondaryStepCopy.length > 0 && _react2.default.createElement(
                'div',
                null,
                secondaryStepCopy
              )
            ),
            _react2.default.createElement(
              'div',
              { id: 'fc-checkout-form-container' },
              this.getCurrentForm()
            ),
            _react2.default.createElement(
              'div',
              { id: 'fc-checkout-nav' },
              secondaryNavButtonCopy.length > 0 && _react2.default.createElement(
                'button',
                { id: 'cf-checkout-nav-secondary', onClick: function onClick() {
                    return _this5.onNewStep('back');
                  } },
                secondaryNavButtonCopy
              ),
              _react2.default.createElement(
                'button',
                { id: 'cf-checkout-nav-primary', onClick: function onClick() {
                    return _this5.onNewStep('next');
                  } },
                primaryNavButtonCopy
              )
            ),
            _react2.default.createElement(
              'div',
              { id: 'cf-checkout-error' },
              errorMessage
            )
          )
        )
      );
    }
  }]);

  return Checkout;
}(_react2.default.Component);

exports.default = Checkout;